import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import type { AxiosRequestConfig } from 'axios'
import {
  fetchItem,
  saveItem,
  uploadDocuments,
  IContactAttributes,
  IContactDocuments
} from '@/api/contacts'

export const useContactStore = defineStore('contact', () => {
  // State: Define the contact object
  const contact = ref<IContactAttributes | null>(null)
  const error = ref<string | null>(null)

  // Actions
  const FetchContact = async (config?: AxiosRequestConfig) => {
    try {
      const response = await fetchItem(config)
      contact.value = response.data.attributes
    } catch (e: any) {
      error.value = e.toString()
    }
  }

  const SaveContact = async (params: IContactAttributes) => {
    return saveItem(params)
  }

  const UploadDocuments = async (payload: IContactDocuments) => {
    await uploadDocuments(payload)
  }

  // Getters
  const currentContact = computed(() => contact.value)

  return {
    // State
    contact,

    // Actions
    FetchContact,
    SaveContact,
    UploadDocuments,

    // Getters
    currentContact
  }
})
